import { Pipe, PipeTransform } from '@angular/core';
import { getTextWidth } from 'src/app/sessions/session/custom-fabric-objects/text-utils';

@Pipe({
  name: 'truncateByWidth',
  standalone: true,
})
export class TruncateByWidthPipe implements PipeTransform {
  transform(value: string, maxWidth: number, font: string): string {
    return truncateUsingWidth(value, maxWidth, font);
  }
}

export const truncateUsingWidth = (value: string, maxWidth: number, font: string): string => {
  if (maxWidth <= 0) {
    return '';
  }

  if (getTextWidth(value, font) <= maxWidth) {
    return value;
  }

  let left = 0;
  let right = value.length;
  let result = value;

  while (left <= right) {
    const mid = Math.floor((left + right) / 2);
    const truncatedText = `${value.slice(0, mid)}...`;
    const width = getTextWidth(truncatedText, font);

    if (width <= maxWidth) {
      result = truncatedText;
      left = mid + 1; // Try for a larger substring
    } else {
      right = mid - 1; // Try for a smaller substring
    }
  }

  if (result !== value) {
    return result;
  }

  for (let dotIndex = 2; dotIndex >= 0; dotIndex--) {
    const dots = '.'.repeat(dotIndex);
    if (getTextWidth(dots, font) <= maxWidth) {
      return dots;
    }
  }

  return '';
};
